// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#AdminUserManage .base-card {
  border-radius: 8px;
}
#AdminUserManage .add-account-button {
  width: fit-content;
  padding: 0 24px;
  flex-shrink: 0;
  white-space: nowrap;
}
#AdminUserManage .fitList .cell-item.sort-cell {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 4px;
}
#AdminUserManage .fitList .cell-item.sort-cell .cell-title-text {
  flex-shrink: 1;
  min-width: 0;
}
#AdminUserManage .fitList .sort-button {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  min-height: 24px;
  padding: 0;
  border: none;
  border-radius: 4px;
  background-color: transparent;
  color: var(--input-placeholder-color);
  cursor: pointer;
  transition: background-color 0.2s, color 0.2s;
}
#AdminUserManage .fitList .sort-button:hover {
  background-color: var(--color-bg);
  color: var(--primary-color-main);
}
#AdminUserManage .fitList .sorting-button {
  color: var(--primary-color-main);
}
#AdminUserManage .fitList .account-name-cell {
  min-width: 0;
}
#AdminUserManage .fitList .account-name-cell .self-tag {
  flex-shrink: 0;
  padding: 1px 8px;
  border-radius: 10px;
  background-color: var(--dark-color-dark-transparent-10);
  color: var(--font_active_sub_color);
  font-size: var(--text-size-small);
  line-height: 18px;
  white-space: nowrap;
}
#AdminUserManage .fitList .account-name-cell .blocked-tag {
  flex-shrink: 0;
  padding: 1px 8px;
  border-radius: 10px;
  background-color: var(--primary-color-lightest);
  color: var(--primary-color-main);
  font-size: var(--text-size-small);
  line-height: 18px;
  white-space: nowrap;
}
#AdminUserManage .fitList .account-name-cell .account-name-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
#AdminUserManage .operate-button {
  padding: 0;
  min-height: 28px;
  max-height: 28px;
  min-width: 72px;
  border-radius: 14px;
  border: 1px solid var(--border-weak-color);
  background-color: var(--white-color-lightest);
  transition: background-color 0.3s color 0.3s border 0.3s;
}
#AdminUserManage .operate-button:hover {
  background-color: var(--dark-color-main);
  color: var(--white-color-main);
}
#AdminUserManage .operate-button.danger:hover {
  background-color: var(--danger-color-main);
  border: 1px solid var(--danger-color-main);
  color: var(--white-color-lightest);
}
#AdminUserManage .operate-button:disabled, #AdminUserManage .operate-button.disabled, #AdminUserManage .operate-button.danger.disabled {
  border: 1px solid var(--disabled-border-color);
  background-color: var(--input-bg-color);
  color: var(--disabled-font-color);
  cursor: default;
  pointer-events: none;
}
#AdminUserManage .operate-button .operate-label {
  height: 24px;
}
#AdminUserManage .Pagination, #AdminUserManage .pagination {
  margin: 0 auto;
}

#account-form-modal .account-form {
  width: 100%;
  min-width: 320px;
}
#account-form-modal .account-form .account-form-row {
  width: 100%;
}
#account-form-modal .account-form .account-form-label {
  text-align: left;
}
#account-form-modal .account-form .password-area {
  width: 100%;
}
#account-form-modal .account-form .password-area .has-regenerate-button {
  padding-right: 40px;
}
#account-form-modal .account-form .password-area .password-regenerate-button {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 4px;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  min-height: 32px;
  padding: 0;
  border: none;
  border-radius: 4px;
  background-color: transparent;
  color: var(--font_active_sub_color);
  cursor: pointer;
  transition: background-color 0.2s, color 0.2s;
}
#account-form-modal .account-form .password-area .password-regenerate-button:hover {
  background-color: var(--color-bg);
  color: var(--primary-color-main);
}
#account-form-modal .account-form .account-form-unlock-login {
  border-top: 1px solid var(--border-weak-color);
  color: var(--primary-color-main);
  padding-top: 16px;
}
#account-form-modal .account-form .account-unlock-login-switch {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  width: fit-content;
}
#account-form-modal .account-form .account-unlock-login-switch.disabled {
  cursor: default;
}
#account-form-modal .account-form .account-unlock-login-switch input[type=checkbox] {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
  pointer-events: none;
}
#account-form-modal .account-form .account-unlock-login-switch .switch-track {
  position: relative;
  display: inline-block;
  width: 52px;
  height: 28px;
  background-color: var(--dark-color-light, #adb5bd);
  border-radius: 999px;
  transition: background-color 0.2s ease-in-out;
}
#account-form-modal .account-form .account-unlock-login-switch .switch-thumb {
  position: absolute;
  top: 3px;
  left: 3px;
  width: 22px;
  height: 22px;
  background-color: #ffffff;
  border-radius: 50%;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  transition: transform 0.2s ease-in-out;
}
#account-form-modal .account-form .account-unlock-login-switch.on .switch-track {
  background-color: var(--primary-color-main, #1F3A5F);
}
#account-form-modal .account-form .account-unlock-login-switch.on .switch-thumb {
  transform: translateX(24px);
}
#account-form-modal .account-form .copy-account-row {
  justify-content: flex-end;
}
#account-form-modal .account-form .copy-account-button {
  width: fit-content;
  min-width: 220px;
  padding: 0 16px;
  min-height: 32px;
  max-height: 32px;
  border-radius: 16px;
  border: 1px solid var(--border-weak-color);
  background-color: var(--white-color-lightest);
  transition: background-color 0.3s, color 0.3s;
}
#account-form-modal .account-form .copy-account-button:hover {
  background-color: var(--dark-color-main);
  color: var(--white-color-main);
}
#account-form-modal .account-form .copy-account-button.copied, #account-form-modal .account-form .copy-account-button.copied:hover {
  border: 1px solid var(--dark-color-main);
  background-color: var(--dark-color-main);
  color: var(--white-color-main);
}
#account-form-modal .account-form .copy-account-button:disabled, #account-form-modal .account-form .copy-account-button.disabled {
  border: 1px solid var(--disabled-border-color);
  background-color: var(--input-bg-color);
  color: var(--disabled-font-color);
  cursor: default;
  pointer-events: none;
}
#account-form-modal .ev-modal-footer, #account-form-modal .ev-modal-footer .button-row {
  height: auto;
  max-height: none;
  min-height: 36px;
}
#account-form-modal .account-form-note {
  margin-right: auto;
  align-items: center;
  max-width: 60%;
  padding-right: 16px;
  text-align: left;
  line-height: 1.4;
}

#account-delete-modal .account-delete-message {
  width: 100%;
  min-width: 320px;
  text-align: left;
}`, "",{"version":3,"sources":["webpack://./src/components/admin/parts/AdminUserManage.scss"],"names":[],"mappings":"AACI;EACI,kBAAA;AAAR;AAII;EACI,kBAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;AAFR;AAUQ;EACI,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,QAAA;AARZ;AAWY;EACI,cAAA;EACA,YAAA;AAThB;AAaQ;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,6BAAA;EACA,qCAAA;EACA,eAAA;EACA,6CAAA;AAXZ;AAaY;EACI,iCAAA;EACA,gCAAA;AAXhB;AAgBQ;EACI,gCAAA;AAdZ;AAmBQ;EACI,YAAA;AAjBZ;AAmBY;EACI,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,uDAAA;EACA,mCAAA;EACA,iCAAA;EACA,iBAAA;EACA,mBAAA;AAjBhB;AAoBY;EACI,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,+CAAA;EACA,gCAAA;EACA,iCAAA;EACA,iBAAA;EACA,mBAAA;AAlBhB;AAqBY;EACI,gBAAA;EACA,uBAAA;EACA,mBAAA;AAnBhB;AAwBI;EACI,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EAEA,0CAAA;EACA,6CAAA;EACA,wDAAA;AAvBR;AAyBQ;EACI,wCAAA;EACA,8BAAA;AAvBZ;AA2BY;EACI,0CAAA;EACA,0CAAA;EACA,kCAAA;AAzBhB;AA+BQ;EACI,8CAAA;EACA,uCAAA;EACA,iCAAA;EACA,eAAA;EACA,oBAAA;AA7BZ;AAgCQ;EACI,YAAA;AA9BZ;AAmCI;EACI,cAAA;AAjCR;;AAuCI;EACI,WAAA;EACA,gBAAA;AApCR;AAsCQ;EACI,WAAA;AApCZ;AAuCQ;EACI,gBAAA;AArCZ;AAyCQ;EACI,WAAA;AAvCZ;AA0CY;EACI,mBAAA;AAxChB;AA2CY;EACI,kBAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;EAEA,YAAA;EACA,kBAAA;EACA,6BAAA;EAEA,mCAAA;EACA,eAAA;EACA,6CAAA;AA5ChB;AA8CgB;EACI,iCAAA;EACA,gCAAA;AA5CpB;AAiDQ;EACI,8CAAA;EACA,gCAAA;EACA,iBAAA;AA/CZ;AAmDQ;EACI,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,kBAAA;AAjDZ;AAmDY;EACI,eAAA;AAjDhB;AAoDY;EACI,kBAAA;EACA,UAAA;EACA,QAAA;EACA,SAAA;EACA,oBAAA;AAlDhB;AAqDY;EACI,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,kDAAA;EACA,oBAAA;EACA,6CAAA;AAnDhB;AAsDY;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,wCAAA;EACA,sCAAA;AApDhB;AAwDgB;EACI,oDAAA;AAtDpB;AAwDgB;EACI,2BAAA;AAtDpB;AA4DQ;EACI,yBAAA;AA1DZ;AA6DQ;EACI,kBAAA;EAEA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EAEA,0CAAA;EACA,6CAAA;EACA,6CAAA;AA7DZ;AA+DY;EACI,wCAAA;EACA,8BAAA;AA7DhB;AAiEY;EACI,wCAAA;EACA,wCAAA;EACA,8BAAA;AA/DhB;AAkEY;EACI,8CAAA;EACA,uCAAA;EACA,iCAAA;EACA,eAAA;EACA,oBAAA;AAhEhB;AAsEI;EACI,YAAA;EACA,gBAAA;EACA,gBAAA;AApER;AAwEI;EAEI,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;AAvER;;AA4EI;EACI,WAAA;EACA,gBAAA;EACA,gBAAA;AAzER","sourcesContent":["#AdminUserManage{\n    .base-card{\n        border-radius: 8px;\n    }\n\n    // ページヘッダーの右端に配置するため、タイトルに押し出されて縮まないようにする\n    .add-account-button{\n        width: fit-content;\n        padding: 0 24px;\n        flex-shrink: 0;\n        white-space: nowrap;\n    }\n\n    // ソート可能な列見出し\n    // FitList共通のスタイルには display:flex が無く、ソートボタンに当たる button-hidden も\n    // 未定義でButtonの基底スタイル(min-height:40px 等)が効いてしまうため、このページ内で整える\n    .fitList{\n        // ソートアイコンは列の右端ではなく、見出しラベルのすぐ右隣に置く\n        .cell-item.sort-cell{\n            display: flex;\n            align-items: center;\n            justify-content: flex-start;\n            gap: 4px;\n\n            // ラベルが長い場合はラベル側を縮め、アイコンは常にラベルへ隣接させる\n            .cell-title-text{\n                flex-shrink: 1;\n                min-width: 0;\n            }\n        }\n\n        .sort-button{\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            flex-shrink: 0;\n            width: 24px;\n            height: 24px;\n            min-height: 24px;\n            padding: 0;\n            border: none;\n            border-radius: 4px;\n            background-color: transparent;\n            color: var(--input-placeholder-color);\n            cursor: pointer;\n            transition: background-color 0.2s, color 0.2s;\n\n            &:hover{\n                background-color: var(--color-bg);\n                color: var(--primary-color-main);\n            }\n        }\n\n        // ソート中の列は矢印を濃く表示する\n        .sorting-button{\n            color: var(--primary-color-main);\n        }\n\n        // ログイン中のアカウントの行\n        // 「自分」が名前の一部に見えないよう、タグとして名前の前に置く\n        .account-name-cell{\n            min-width: 0;\n\n            .self-tag{\n                flex-shrink: 0;\n                padding: 1px 8px;\n                border-radius: 10px;\n                background-color: var(--dark-color-dark-transparent-10);\n                color: var(--font_active_sub_color);\n                font-size: var(--text-size-small);\n                line-height: 18px;\n                white-space: nowrap;\n            }\n\n            .blocked-tag{\n                flex-shrink: 0;\n                padding: 1px 8px;\n                border-radius: 10px;\n                background-color: var(--primary-color-lightest);\n                color: var(--primary-color-main);\n                font-size: var(--text-size-small);\n                line-height: 18px;\n                white-space: nowrap;\n            }\n\n            .account-name-text{\n                overflow: hidden;\n                text-overflow: ellipsis;\n                white-space: nowrap;\n            }\n        }\n    }\n\n    .operate-button{\n        padding: 0;\n        min-height: 28px;\n        max-height: 28px;\n        min-width: 72px;\n        border-radius: 14px;\n\n        border: 1px solid var(--border-weak-color);\n        background-color: var(--white-color-lightest);\n        transition: background-color 0.3s color 0.3s border 0.3s;\n\n        &:hover{\n            background-color: var(--dark-color-main);\n            color: var(--white-color-main);\n        }\n\n        &.danger{\n            &:hover{\n                background-color: var(--danger-color-main);\n                border: 1px solid var(--danger-color-main);\n                color: var(--white-color-lightest);\n            }\n        }\n\n        // 操作できない場合は非活性であることが分かる見た目にする\n        // ※danger等の修飾クラスより後に定義して打ち消す\n        &:disabled, &.disabled, &.danger.disabled{\n            border: 1px solid var(--disabled-border-color);\n            background-color: var(--input-bg-color);\n            color: var(--disabled-font-color);\n            cursor: default;\n            pointer-events: none;\n        }\n\n        .operate-label{\n            height: 24px;\n        }\n    }\n\n    // ページャーはカードの中央に配置する\n    .Pagination, .pagination{\n        margin: 0 auto;\n    }\n}\n\n// モーダルはページのルート要素の外に描画されるため、ページIDの外側に定義する\n#account-form-modal{\n    .account-form{\n        width: 100%;\n        min-width: 320px;\n\n        .account-form-row{\n            width: 100%;\n        }\n\n        .account-form-label{\n            text-align: left;\n        }\n\n        // パスワード入力欄と再生成ボタンを重ねて配置する\n        .password-area{\n            width: 100%;\n\n            // 再生成ボタンと入力値が重ならないよう、入力欄の右側に余白を作る\n            .has-regenerate-button{\n                padding-right: 40px;\n            }\n\n            .password-regenerate-button{\n                position: absolute;\n                top: 0;\n                bottom: 0;\n                right: 4px;\n                margin: auto;\n\n                display: flex;\n                align-items: center;\n                justify-content: center;\n                width: 32px;\n                height: 32px;\n                min-height: 32px;\n                padding: 0;\n\n                border: none;\n                border-radius: 4px;\n                background-color: transparent;\n                // 非活性に見えないよう、通常の文字色で表示する\n                color: var(--font_active_sub_color);\n                cursor: pointer;\n                transition: background-color 0.2s, color 0.2s;\n\n                &:hover{\n                    background-color: var(--color-bg);\n                    color: var(--primary-color-main);\n                }\n            }\n        }\n\n        .account-form-unlock-login {\n            border-top: 1px solid var(--border-weak-color);\n            color: var(--primary-color-main);\n            padding-top: 16px;\n        }\n\n        // ログイン制限解除 ON/OFF トグルスイッチ\n        .account-unlock-login-switch {\n            position: relative;\n            display: inline-flex;\n            align-items: center;\n            gap: 12px;\n            cursor: pointer;\n            user-select: none;\n            width: fit-content;\n\n            &.disabled {\n                cursor: default;\n            }\n\n            input[type=\"checkbox\"] {\n                position: absolute;\n                opacity: 0;\n                width: 0;\n                height: 0;\n                pointer-events: none;\n            }\n\n            .switch-track {\n                position: relative;\n                display: inline-block;\n                width: 52px;\n                height: 28px;\n                background-color: var(--dark-color-light, #adb5bd);\n                border-radius: 999px;\n                transition: background-color 0.2s ease-in-out;\n            }\n\n            .switch-thumb {\n                position: absolute;\n                top: 3px;\n                left: 3px;\n                width: 22px;\n                height: 22px;\n                background-color: #ffffff;\n                border-radius: 50%;\n                box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\n                transition: transform 0.2s ease-in-out;\n            }\n\n            &.on {\n                .switch-track {\n                    background-color: var(--primary-color-main, #1F3A5F);\n                }\n                .switch-thumb {\n                    transform: translateX(24px);\n                }\n            }\n        }\n\n        // ログイン情報のコピーボタンはフォームの右下に寄せる\n        .copy-account-row{\n            justify-content: flex-end;\n        }\n\n        .copy-account-button{\n            width: fit-content;\n            // 「コピーしました」に切り替わってもボタン幅がガタつかないようにする\n            min-width: 220px;\n            padding: 0 16px;\n            min-height: 32px;\n            max-height: 32px;\n            border-radius: 16px;\n\n            border: 1px solid var(--border-weak-color);\n            background-color: var(--white-color-lightest);\n            transition: background-color 0.3s, color 0.3s;\n\n            &:hover{\n                background-color: var(--dark-color-main);\n                color: var(--white-color-main);\n            }\n\n            // コピー直後は完了状態が分かるよう色を固定し、ホバーの反転を効かせない\n            &.copied, &.copied:hover{\n                border: 1px solid var(--dark-color-main);\n                background-color: var(--dark-color-main);\n                color: var(--white-color-main);\n            }\n\n            &:disabled, &.disabled{\n                border: 1px solid var(--disabled-border-color);\n                background-color: var(--input-bg-color);\n                color: var(--disabled-font-color);\n                cursor: default;\n                pointer-events: none;\n            }\n        }\n    }\n\n    // Modal共通のフッターは1行想定で高さが36px固定のため、注釈が2行になっても潰れないよう緩める\n    .ev-modal-footer, .ev-modal-footer .button-row{\n        height: auto;\n        max-height: none;\n        min-height: 36px;\n    }\n\n    // フッター左下の注釈(キャンセルボタンの隣)\n    .account-form-note{\n        // .button-rowがflex-endのため、autoマージンで左端まで押し出す\n        margin-right: auto;\n        align-items: center;\n        max-width: 60%;\n        padding-right: 16px;\n        text-align: left;\n        line-height: 1.4;\n    }\n}\n\n#account-delete-modal{\n    .account-delete-message{\n        width: 100%;\n        min-width: 320px;\n        text-align: left;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
